<template>
  <v-container fluid class="b-container">
    <v-sheet class="pa-3">
      <v-toolbar flat height="90">
        <v-spacer></v-spacer>
        <v-col cols="12" sm="4" class="pa-0">
          <b-search-field v-model="search"></b-search-field>
        </v-col>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="gifts"
        :footer-props="{
          itemsPerPageOptions: [12],
          showCurrentPage: true,
          pageText: `${page * 12 - 11}-${
            page * 12 <= serverItemsLength ? page * 12 : serverItemsLength
          } ${translations.paginationText[lang]} ${serverItemsLength}`,
        }"
        :page.sync="page"
        :server-items-length="serverItemsLength"
        :loading="loading"
        disable-sort
        class="b-outlined"
      >
        <template v-slot:item.image="{ item }">
          <v-img :src="item.image" width="70"></v-img>
        </template>
      </v-data-table>
    </v-sheet>
  </v-container>
</template>

<script>
import { mdiMagnify, mdiChevronDown } from '@mdi/js';
import translations from '@/utils/translations/supplierPanel/gifts';
import { mapMutations, mapState, mapActions } from 'vuex';
import debounce from 'lodash/debounce';

export default {
  name: 'Gifts',

  mixins: [translations],

  data() {
    return {
      icons: {
        mdiMagnify,
        mdiChevronDown,
      },
      search: '',
      page: +this.$route.query.page,
    };
  },

  computed: {
    ...mapState('supplierPanel/gifts', ['gifts']),
    ...mapState(['loading', 'serverItemsLength']),

    lang() {
      return this.$route.params.lang;
    },
    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
    headers() {
      return [
        {
          text: this.translations.image[this.lang],
          value: 'image',
        },
        {
          text: this.translations.name[this.lang],
          value: 'title',
        },
        {
          text: this.translations.type[this.lang],
          value: `gift_type.name[${this.lang}]`,
        },
        {
          text: this.translations[this.storeMode][this.lang],
          value: 'points',
        },
      ];
    },

    query() {
      let query = '?';

      for (let key in this.$route.query) {
        query += `${key}=${this.$route.query[key]}&`;
      }

      return query.slice(0, query.length - 1);
    },
  },

  watch: {
    $route(val) {
      if (!val.query.page) {
        this.$router.push({
          query: {
            page: 1,
            ...this.$route.query,
          },
        });
      }
      this.getGifts(this.query);
    },

    page(page) {
      this.$router.push({ query: { ...this.$route.query, page } });
    },

    search(val) {
      if (val == null) {
        this.getGifts(this.query);
      } else {
        this.debouncedSearch();
      }
    },
  },

  methods: {
    ...mapActions('supplierPanel/gifts', ['getGifts']),

    handleSearch() {
      this.getGifts(`?q=${this.search}`);
    },
  },

  mounted() {
    this.getGifts(this.query);
  },

  beforeCreate() {
    if (!this.$route.query.page) {
      this.$router.push({
        query: {
          page: 1,
          ...this.$route.query,
        },
      });
    }
  },
  created() {
    this.debouncedSearch = debounce(this.handleSearch, 500);
  },
};
</script>
